const PHRASE = "KOMFORT • BEZPIECZEŃSTWO • PUNKTUALNOŚĆ • ";

export const Marquee = () => (
  <section
    aria-hidden="true"
    data-testid="slogan-marquee"
    className="overflow-hidden border-y border-white/10 py-8 md:py-10"
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((half) => (
        <span
          key={half}
          className="text-outline font-display text-6xl font-extrabold tracking-tight md:text-8xl"
        >
          {PHRASE.repeat(3)}
        </span>
      ))}
    </div>
  </section>
);
